import { Component, OnInit } from '@angular/core';
import { ChartComponent } from '../chart/chart.component';
import { donutChartInfos } from 'src/app/shared/data/chart-data';
import { HttpService } from 'src/app/shared/services/http.service';
import { AppService } from 'src/app/app.service';
import { RateAgreementTableComponent } from 'src/app/shared/components/rate-agreement-table/rate-agreement-table.component';
import { Router } from '@angular/router';
// import * as jwt from 'jsonwebtoken';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment.dev';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  standalone:false,
  styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent  implements OnInit {
  public donutChartInfos:any[]=[];
  barChartInfos: {};
  userData:any;

  constructor(private httpService:HttpService, private appService:AppService, private router:Router){
    this.barChartInfos={}
    this.appService.mineBtnEmit.subscribe((evt:any)=>{
      this.donutChartInfos = [];
      this.getRatiofromDB();
    });
    setTimeout(() => {  
      this.getRatiofromDB();
    });
    let authToken = CryptoJS.AES.encrypt(environment.AUTHTOKEN_KEY,'authentication').toString()
    sessionStorage.setItem("authToken",authToken)
    this.appService.onCheckSetItem(true)
    
  }

  ngOnInit(): void {
   setTimeout(() => {
    this.toGetUserDetails();
   }, 1000);
  }

  getRatiofromDB(){
    this.appService.isLoading = true;
    let userData = sessionStorage.getItem("user-data");
    this.userData = userData?JSON.parse(userData):null;
    this.donutChartInfos =[];

    this.httpService.getRatioForChart(this.appService.mineBtnEbaled?this.userData?.UserID:0)
      .subscribe((res: any) => {
        this.appService.isLoading = false;
        if (res.length > 0) {
          this.donutChartInfos = [{title:"Rate Agreement",data: [
            { asset: "draft", amount: res[0].RateAgreementDraftCount },
              { asset: "active", amount: res[0].RateAgreementActiveCount }
            ],totalAgreement:res[0].RateAgreementDraftCount+res[0].RateAgreementActiveCount},{title:"Due Rate Agreement",data: [
              { asset: "draft", amount: res[0].DueForTermination },
                { asset: "active", amount: res[0].DueForAutoExtension }
              ],totalAgreement:res[0].DueForAutoExtension+res[0].DueForTermination},{title:"Draft Rate Agreement",data:[
                { asset: "draft", amount: res[0].DraftFuelEscalator },
                  { asset: "active", amount: res[0].DraftManual },
                ],totalAgreement: res[0].DraftManual+res[0].DraftFuelEscalator}]
          
        }
      })
  }

  toGetUserDetails(){
    let user = sessionStorage.getItem("SSO_user_data");
    let userData = user?JSON.parse(user):null;
    
    this.appService.isLoading = true;
    this.httpService.getUserDetails(userData.unique_name)//userData.unique_name
      .subscribe((res: any) => {        
        this.appService.isLoading = false;
        if (res.length > 0) {
          this.appService.setUserDetails(res[0])
          
          this.appService.selectedTheme = res[0].Email.includes('dhl') ? true:false
          sessionStorage.setItem("user-data",JSON.stringify(res[0]))
          this.appService.onCheckSetItem(true);
          this.appService.headerLoadingEmitter.emit('')
        }
        else{
          this.appService.isLoggedIn=false;
          this.router.navigateByUrl('/page-not-found')
          this.httpService.openSnackBar( 'Please Reach out to Admin!' )
        }
      })
  //   (error)=>{
  //       this.appService.isLoggedIn=false;
  //       this.router.navigateByUrl('/page-not-found')
  //       // debugger;
  //       // 
  //       this.httpService.openSnackBar('Please add email address! OR Contact Admin!' )
  //   })
  // return;
  }
}
